import { makeStyles } from '@material-ui/core';

import { COLOR_TONE } from '../../../../shared/styles/colors';

export default makeStyles({
  icon: { color: COLOR_TONE.gray['30'] },
});
